import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import KundaliChart from "../KundaliChart";
import api from "../../lib/api";

const ORDER = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"];

function PlanetTable({ chart }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-[12px]" style={{ color: "#FFF6E0" }} data-testid="slot-chart-table">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wider opacity-60">
            <th className="py-1.5 pr-2">Planet</th><th className="pr-2">Sign</th><th className="pr-2">House</th><th className="pr-2">Nakshatra</th><th>Nak. lord</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-amber-400/20" data-testid="slot-row-Lagna">
            <td className="py-1.5 pr-2 font-semibold">Lagna</td>
            <td className="pr-2">{chart.lagna.rashi} {chart.lagna.degrees_in_rashi}°</td>
            <td className="pr-2">1</td>
            <td className="pr-2">{chart.lagna.nakshatra || "—"}</td>
            <td>{chart.lagna.nakshatra_lord || "—"}</td>
          </tr>
          {ORDER.filter((p) => chart.planets[p]).map((p) => {
            const v = chart.planets[p];
            return (
              <tr key={p} className="border-t border-amber-400/20" data-testid={`slot-row-${p}`}>
                <td className="py-1.5 pr-2 font-semibold">{p}{v.retrograde ? " ℞" : ""}</td>
                <td className="pr-2">{v.rashi} {v.degrees_in_rashi}°</td>
                <td className="pr-2">{v.house_from_lagna}</td>
                <td className="pr-2" style={{ color: "#FFD27A" }} data-testid={`slot-nak-${p}`}>{v.nakshatra} · pada {v.pada}</td>
                <td>{v.nakshatra_lord}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export function SlotChartDialog({ slot, place, timezone, onClose }) {
  const [chart, setChart] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!slot) return;
    setChart(null);
    setError("");
    api.post("/tools/baby-muhurat/chart", { date: slot.date, time: slot.time, place, timezone })
      .then(({ data }) => setChart(data))
      .catch((e) => setError(e?.response?.data?.detail || "Couldn't load the chart."));
  }, [slot, place, timezone]);

  return (
    <Dialog open={!!slot} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto border border-amber-500/40 !text-[#FFF6E0]" style={{ background: "#121633", color: "#FFF6E0" }} data-testid="slot-chart-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl" style={{ color: "#FFD27A" }}>Birth chart at {slot?.time}</DialogTitle>
          <DialogDescription style={{ color: "rgba(255,246,224,0.7)" }} data-testid="slot-chart-subtitle">
            {slot && new Date(`${slot.date}T00:00:00`).toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "long", year: "numeric" })} · {place} ({timezone})
          </DialogDescription>
        </DialogHeader>
        {error && <p className="text-sm text-rose-500" data-testid="slot-chart-error">{error}</p>}
        {!chart && !error && <div className="h-72 rounded-xl bg-amber-100/40 animate-pulse" data-testid="slot-chart-loading" />}
        {chart && (
          <div className="grid md:grid-cols-[auto_1fr] gap-5 items-start">
            <div className="flex justify-center rounded-xl p-2" data-testid="slot-chart-d1">
              <KundaliChart kundali={chart} size={typeof window !== "undefined" && window.innerWidth < 640 ? 280 : 300} label="D1 · Rasi" />
            </div>
            <PlanetTable chart={chart} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
